











import { Component, Vue } from "vue-property-decorator";
import { State, Getter, Action, namespace } from "vuex-class";
import { IPortalUser } from "../../models/interfaces/authentication/portal-user.model.interface";

const UserModule = namespace("userModule");

@Component({})
export default class HeaderDropdown extends Vue {
  @UserModule.Getter public user: IPortalUser | null;
  @UserModule.Action public logout;

  get userName(): string {
    if (!this.user) {
      return "";
    }

    return this.user.fullName;
  }

  public userLogout() {
    this.logout().then((result) => this.processLogoutResult());
  }

  private processLogoutResult() {
    if (!this.user) {
      this.$router.push({
        name: "LoginPage"
      });
    }
  }
}
